<template>
  <div class="pos_r of_h">
    <div class="pos_a top_380 z_index_1 left_0 cursor_p btn" @click="changePage(-1)">
      <i class="font_family icon-jiantouzuo"></i>
    </div>
    <div class="pos_a top_380 z_index_1 right_0 cursor_p btn" @click="changePage(1)">
      <i class="font_family icon-jiantouyou"></i>
    </div>
    <div v-for="(item,index) in list" :key="item.text">
      <div class="pos_r flex j_c_c" v-show="index === current">
        <img :src="item.img" class="h_800" />
        <div class="t_a_c m_lr_auto pos_a top_100 w_100p c_fff">
          <div class="f_s_16">{{item.text}}</div>
          <div class="visuallyhidden f_w_600 f_s_34 m_t_20">{{item.slogan}}</div>
          <div class="f_s_20 f_w_500 l_h_24 m_t_10">{{item.headline}}</div>
          <div class="flex j_c_c m_t_20 f_s_12">
            <!-- <div class="b_r_20 b_1_s_fff p_4 m_r_20 cursor_p btn">了解更多</div> -->
            <!-- <div class="b_r_20 b_1_s_fff p_ cursor_p btn">立即购买</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerSwiperSlide",
  props: {
    list: {
      type: Array
    }
  },
  data() {
    return {
      // 定时器
      interval: null,
      current: 0
    };
  },
  created() {
    this.timer();
  },
  methods: {
    /** 定时器 3秒执行一次 */
    timer() {
      if (this.interval) return;
      this.interval = setInterval(() => {
        this.changePage(1);
      }, 3000);
    },
    /**  */
    changePage(count) {
      if (count === 1 && this.current === this.list.length - 1) {
        this.current = 0;
      } else if (count === -1 && this.current === 0) {
        this.current = this.list.length - 1;
      } else {
        this.current += count;
      }
    }
  }
};
</script>

<style scoped>
.visuallyhidden {
  font-family: "Open Sans", "PingFang SC", "Microsoft YaHei", "Helvetica Neue",
    "Hiragino Sans GB", "WenQuanYi Micro Hei", Arial, sans-serif;
}
.top_100 {
  top: 100px;
}
.top_380 {
  top: 360px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: #0000003b;
  width: 40px;
  color: #fff;
  border-radius: 4px;
}
</style>
